module.exports = __webpack_public_path__ + "img/icon-mastercard.e9425816.svg";